import React, { Fragment, useEffect, useState } from 'react';
import { Breadcrumbs } from '../../../AbstractElements';
import { Loader2 } from 'lucide-react';
import {
    getCustomerDemographics,
    getRevenueSummary,
    getTopClasses,
    getTopProducts,
    ExportAnalytics,
} from './../../../api-handle/revenue-analyticsApi';
import RevenueSummaryCards from './RevenueSummaryCards';
import RevenueTrendChart from './RevenueTrendChart';
import { TopProducts } from "./TopProducts"
import { TopClasses } from './TopClasses';
import CustomerDemographics from './CustomerDemographics';

const RevenueAnalytics = () => {
    const [loading, setLoading] = useState(false);
    const [revenueSummary, setRevenueSummary] = useState(null);
    const [topProducts, setTopProducts] = useState([]);
    const [topclasses, setTopclasses] = useState([]);
    const [demographics, setDemoGraphics] = useState(null);

    const fetchRevenueSummary = async () => {
        try {
            setLoading(true);
            const revenue = await getRevenueSummary();
            setRevenueSummary(revenue);
            setLoading(false);
        } catch (err) {
            console.error('Failed to fetch revenue summary:', err);
        }
    };

    const fetchTopProducts = async () => {
        try {
            setLoading(true);
            const res = await getTopProducts();
            setTopProducts(res?.products);
            setLoading(false);
        } catch (err) {
            console.error('Failed to fetch top products:', err);
        }
    };

    const fetchTopclasses = async () => {
        try {
            setLoading(true);
            const res = await getTopClasses();
            setTopclasses(res?.classes);
            setLoading(false);
        } catch (err) {
            console.error('Failed to fetch top classes:', err);
        }
    };

    const fetchCustomerDemographics = async () => {
        try {
            setLoading(true);
            const res = await getCustomerDemographics();
            setDemoGraphics(res);
            setLoading(false);
        } catch (err) {
            console.error('Failed to fetch customer demographics:', err);
        }
    };

    const handleExportAnalytics = async () => {
        try {
            setLoading(true);
            await ExportAnalytics(); // Ensure this triggers backend file download or returns file URL
            setLoading(false);
        } catch (error) {
            console.error('Failed to export analytics:', error);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchRevenueSummary();
        fetchTopProducts();
        fetchTopclasses();
        fetchCustomerDemographics();
    }, []);

    return (
        <Fragment>
            <Breadcrumbs mainTitle="Revenue and Analytics" parent="Revenue and Reports" title="Revenue Analytics" />

            {/* Export Button */}
            <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '16px 0' }}>
                <button
                    onClick={handleExportAnalytics}
                    style={{
                        backgroundColor: '#33bdbf',
                        color: '#fff',
                        padding: '10px 20px',
                        borderRadius: '8px',
                        border: 'none',
                        cursor: 'pointer',
                        fontWeight: '500',
                        fontSize: '0.95rem',
                        boxShadow: '0 2px 6px rgba(99, 102, 241, 0.3)',
                        transition: 'all 0.3s ease',
                    }}
                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#33bdbf'}
                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#33bdbf'}
                >
                    Export Analytics
                </button>
            </div>

            {loading ? (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '60vh',
                    }}
                >
                    <Loader2
                        size={48}
                        color="#33bdbf"
                        style={{
                            animation: 'spin 1s linear infinite',
                            filter: 'drop-shadow(0 0 6px #6366F1)',
                            transform: 'scale(1.1)',
                        }}
                    />
                </div>
            ) : (
                <>
                    {revenueSummary && <RevenueSummaryCards data={revenueSummary} />}
                    <RevenueTrendChart />
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            gap: '1.5rem',
                            flexWrap: 'wrap',
                        }}
                    >
                        <div style={{ flex: '1 1 48%', minWidth: '300px', minHeight: "500px" }}>
                            <TopProducts products={topProducts} />
                        </div>
                        <div style={{ flex: '1 1 48%', minWidth: '300px', minHeight: "500px" }}>
                            <TopClasses classes={topclasses} />
                        </div>
                    </div>
                    {demographics && <CustomerDemographics demographics={demographics} />}
                </>
            )}
        </Fragment>
    );
};

export default RevenueAnalytics;
